import { render, staticRenderFns } from "./AdminEmbroiderySettingsScreen.vue?vue&type=template&id=1db1f2d8&scoped=true&"
import script from "./AdminEmbroiderySettingsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminEmbroiderySettingsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1f2d8",
  null
  
)

export default component.exports